import {Component, EventEmitter, Output} from '@angular/core';
import {XButtonComponent} from "../../../shared/x-kit/components/x-button/x-button.component";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-payment-overlay',
  standalone: true,
  imports: [XButtonComponent, TranslatePipe],
  templateUrl: './payment-overlay.component.html',
  styleUrl: './payment-overlay.component.less',
})
export class PaymentOverlayComponent {
  @Output() openLink = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onBackdropClick(event: MouseEvent) {
    // Закрываем только если клик был на фоне, а не на контенте
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
